import React from 'react';

const ProductSection = ({ title, subtitle, children, bgColor = 'bg-white' }) => {
  return (
    <section className={`py-16 ${bgColor}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {title && (
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#3b7ba8] mb-4">
              {title}
            </h2>
            {subtitle && (
              <p className="text-lg text-[#3b7ba8] max-w-3xl mx-auto">
                {subtitle}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default ProductSection;
